// Provides a v-card with some default structure
<template lang="pug">
v-card.ma-2(:width='width')
    v-toolbar
        v-icon.mr-2(v-if='icon') {{ icon }}
        v-toolbar-title {{ title }}
    slot
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: undefined,
        },
        width: {
            type: String,
            default: '100%',
        },
    },
});
</script>
